module.exports = __webpack_public_path__ + "img/couples_06_H.77e825ed.webp";